<template>
  <div>
    <h4 class="wf-text-xs wf-font-bold wf-uppercase wf-text-gray-500">General Settings</h4>
    <div class="wf-mt-5">
      <div class="wf-flex wf-flex-wrap wf-justify-between wf-items-center">
        <span class="wf-text-xs wf-tracking-wide wf-font-semibold wf-lowercase">Settings Sidebar</span>
        <toggle-button sync v-model="elementToolbar"/>
      </div>
    </div>
    <div class="wf-mt-5">
      <div class="wf-flex wf-flex-wrap wf-justify-between wf-items-center">
        <span class="wf-text-xs wf-tracking-wide wf-font-semibold wf-lowercase">device editor</span>
        <ul class="wf-flex wf-flex-wrap">
          <li class="wf-px-1">
            <button
              class="wf-h-8 wf-w-8 wf-flex wf-rounded wf-items-center wf-justify-center wf-text-lg hover:wf-text-blue-700 focus:wf-outline-none"
              :class="device == 'phone' ? ['wf-text-blue-700', 'wf-bg-blue-100'] : 'wf-text-gray-500'"
              @click.prevent="device = 'phone'"
            ><i class="fas fa-mobile-alt"></i></button>
          </li>
          <li class="wf-px-1">
            <button
              class="wf-h-8 wf-w-8 wf-flex wf-rounded wf-items-center wf-justify-center wf-text-lg hover:wf-text-blue-700 focus:wf-outline-none"
              :class="device == 'tablet' ? ['wf-text-blue-700', 'wf-bg-blue-100'] : 'wf-text-gray-500'"
              @click.prevent="device = 'tablet'"
            ><i class="fas fa-tablet-alt"></i></button>
          </li>
          <li class="wf-px-1">
            <button
              class="wf-h-8 wf-w-8 wf-flex wf-rounded wf-items-center wf-justify-center wf-text-lg hover:wf-text-blue-700 focus:wf-outline-none"
              :class="device == 'desktop' ? ['wf-text-blue-700', 'wf-bg-blue-100'] : 'wf-text-gray-500'"
              @click.prevent="device = 'desktop'"
            ><i class="fas fa-desktop"></i></button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import ArrayManipulation from '../../mixins/ArrayManipulation'
  export default {
    mixins: [ArrayManipulation],
    mounted() {
      // let elementSidebar = JSON.parse(localStorage.getItem('elementSidebar'))
      // this.$store.commit('settingsModule/toggleElementSidebar', elementSidebar)
    },
    computed: {
      device: {
        get() {
          return this.$store.getters['pageModule/device']
        },
        set(device) {
          this.addToObject('pageModule', {device}, 'base')
        } 
      },
      elementToolbar: {
        get() {
          return this.$store.getters['settingsModule/elementSidebar']
        },
        set(value) {
          this.$store.commit('settingsModule/toggleElementSidebar', value)
          if(! value) {
            this.$store.commit('removeEditingElement')
          }
        }
      }
    }
  }
</script>